module.exports = __webpack_public_path__ + "img/12.6c85dea6.png";